import script from "./CommitterAnalyis.vue?vue&type=script&setup=true&lang=js"
export * from "./CommitterAnalyis.vue?vue&type=script&setup=true&lang=js"

import "./CommitterAnalyis.vue?vue&type=style&index=0&id=cff8272e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cff8272e"]])

export default __exports__